import { Injectable } from '@angular/core';
import { SettingsService } from '../data-service/settings.service';
import { SettingsKey } from 'src/app/core/store/settings-config.keys';
import { LabType } from '../enums/lab-type.enum';

@Injectable({
  providedIn: 'root'
})
export class LabsiteCheckService {
  constructor(private settingsService: SettingsService) { }

  async isElimsOrTransitionedToElims(labsiteCode: string, labtype: string, accountCode: string): Promise<boolean> {
    if (labtype !== LabType.ExternalLims) {
      return true;
    }

    const elimsTransitionedLabsiteAccounts =
      await this.settingsService.getSettingValue(SettingsKey.ELIMSTransitionedLabsiteAccounts);

    if (elimsTransitionedLabsiteAccounts) {
      for (const entry of elimsTransitionedLabsiteAccounts) {
        if (entry.AccountCodes && entry.AccountCodes.length > 0) {
          if (entry.AccountCodes.includes(accountCode) && entry.LabsiteCode === labsiteCode) {
            return true;
          }
        }
      }
    }
    return false;
  }
}

